<top-bar-tabs></top-bar-tabs>
<div class="row">
  <div class="col-2"></div>
  <div class="col-7"><contacts-navigation (onSelect)="getPage($event.page,$event.letter,category)"></contacts-navigation></div>
  <div class="col-3">
    <mat-paginator
      [length]="total"
      [pageSize]="perPage"
      (page)="getPage($event, currentLetter,category)"
    ></mat-paginator>
  </div>
</div>
<table mat-table class="stripped-table" [dataSource]="getDataSourceByCategory(category)" matSort>
  @if (category==ContactCategory.PEOPLE) {
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let row"><a href="{{row.url}}" target="_blank" class="data-link">{{row.name}}</a></td>
    </ng-container>
  }
  @if (category==ContactCategory.SPONSORS) {
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Sponsor</th>
      <td mat-cell *matCellDef="let row"><a href="{{row.url}}" target="_blank" class="data-link">{{row.name}}</a></td>
    </ng-container>
  }
  @if (category==ContactCategory.ORGANIZATIONS) {
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Organization</th>
      <td mat-cell *matCellDef="let row"><a href="{{row.url}}" target="_blank" class="data-link">{{row.name}}</a></td>
    </ng-container>
  }
  @if (category==ContactCategory.PEOPLE) {
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
      <td mat-cell *matCellDef="let row"><a href="mailto:{{row.email}}" class="data-link">{{row.email}}</a></td>
    </ng-container>
  }
  @if (category==ContactCategory.ORGANIZATIONS) {
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
      <td mat-cell *matCellDef="let row">{{row.state}}</td>
    </ng-container>
  }
  @if (category!==ContactCategory.SPONSORS) {
    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
      <td mat-cell *matCellDef="let row">{{row.phone}}</td>
    </ng-container>
  }
  @if (category==ContactCategory.PEOPLE) {
    <ng-container matColumnDef="organization">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Organization</th>
      <td mat-cell *matCellDef="let row"><a href="{{row.orgUrl}}" target="_blank" class="data-link">{{row.organization}}</a></td>
    </ng-container>
  }
  @if (category==ContactCategory.ORGANIZATIONS) {
    <ng-container matColumnDef="website">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Website</th>
      <td mat-cell *matCellDef="let row"><a href="{{row.website}}" class="data-link">{{row.website}}</a></td>
    </ng-container>
  }
  @if (category!==ContactCategory.SPONSORS) {
    <ng-container matColumnDef="tags">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Tags</th>
      <td mat-cell *matCellDef="let row">
        @for (tag of row.tags; track tag) {
          <mat-chip-row>
            <mat-chip class="chip-size">
              {{tag}}
            </mat-chip>
          </mat-chip-row>
        }
      </td>
    </ng-container>
  }
  <tr mat-header-row *matHeaderRowDef=columns></tr>
  <tr mat-row *matRowDef="let row; columns: columns"></tr>
</table>
